import * as ChannelService from '@channel.io/channel-web-sdk-loader'
import * as PortOne from '@portone/browser-sdk/v2'
import { format } from 'libphonenumber-js'

import type { components } from '../constants/schema'

import { abrCompleteIdentification } from '../utils/abr'

import { getIdentityVerificationId, identify } from '../api/identification'

import { rootStore } from '../provider/StoreProvider'

/**
 * 서버에 본인인증 UUID 요청 후 PortOne 본인인증 요청
 * @param redirectUrl 인증 후 돌아올 주소
 * @returns PortOne.IdentityVerificationResponse | undefined
 */
export async function requestIdentityVerification(redirectUrl: string) {
  rootStore.commonStore.setIsLoading(true)
  localStorage.setItem('isVerification', 'true')
  const identityVerificationId = await getIdentityVerificationId()

  rootStore.commonStore.setIsLoading(false)

  if (!identityVerificationId) return false

  return await PortOne.requestIdentityVerification({
    redirectUrl,
    identityVerificationId,
    storeId: process.env.REACT_APP_ARTIPIO_PORTONE_STORE_ID as string,
    channelKey: process.env.REACT_APP_ARTIPIO_PORTONE_CHANNEL_KEY,
    windowType: {
      pc: 'POPUP',
      mobile: 'REDIRECTION',
    },
  })
}

/**
 * url 주소값 data화 (주로 identityVerificationId 찾기 위해 사용)
 * @param query url query문
 * @returns ReqQueryIdentification
 */
export function convertIdentityVerificationResult(query: string): components['schemas']['ReqQueryIdentification'] {
  let result = {}
  query.split('&').forEach((data) => {
    const [key, value] = data.split('=')
    result = { ...result, [key]: value }
  })
  return result as components['schemas']['ReqQueryIdentification']
}

/**
 * 본인인증 후 채널톡 및 airbridge 업데이트
 * @param data ReqQueryIdentification
 * @returns IdentificationDto | undefined
 */
export async function requestIdentify(data: components['schemas']['ReqQueryIdentification']) {
  try {
    const response = await identify(data)

    const atProfile: Record<string, any> = {}

    if (response?.danalPhoneNumber) {
      atProfile.mobileNumber = format(response.danalPhoneNumber, 'KR', 'E.164')
    }
    ChannelService.updateUser({ language: 'ko', profile: atProfile })

    abrCompleteIdentification()
    ChannelService.track('complete_identification')

    return response
  } catch (error) {
    console.log({ error })
    throw error
  }
}
